import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaTimePickerColumn from './VaTimePickerColumn.vue'

export const VaTimePickerColumn = withConfigTransport(_VaTimePickerColumn)
